import { type MouseEventHandler } from 'react'
import { useDebounce } from 'use-debounce'

import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover/popover'

import { cn } from '@/lib/utils'

export interface CellContentAssigneesProps {
  assignees: string[]
}

export const CellContentAssignees = ({ assignees }: CellContentAssigneesProps) => {
  const [isOpenPopover, setIsOpenPopover] = useDebounce(false, 250)

  const assigneesCount = assignees?.length
  const firstAssignee = assignees[0]

  const handleMouseEnter = () => {
    setIsOpenPopover(true)
  }

  const handleMouseLeave = () => {
    setIsOpenPopover(false)
  }

  const handleClickPopoverTrigger: MouseEventHandler = ($event) => {
    $event.stopPropagation()
    $event.preventDefault()
  }

  const handleClickPopoverContent: MouseEventHandler = ($event) => {
    $event.stopPropagation()
    $event.preventDefault()
  }

  return (
    <div className={cn('flex items-center gap-x-2.5')}>
      <div className={cn('text-sm font-normal text-slate-900')}>
        {assigneesCount === 0 && '-'}
        {assigneesCount > 0 && firstAssignee}
      </div>
      {assigneesCount > 1 && (
        <Popover open={isOpenPopover} onOpenChange={setIsOpenPopover}>
          <PopoverTrigger
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClickPopoverTrigger}
          >
            <span
              className={cn(
                'inline-flex items-center justify-center',
                'bg-slate-200',
                'rounded-[5px]',
                'text-sm font-medium text-slate-900',
                'px-1',
                'hover:bg-slate-500 hover:text-slate-50'
              )}
            >
              +{assignees.slice(1).length}
            </span>
          </PopoverTrigger>
          <PopoverContent
            align="start"
            className={cn('w-fit', 'p-1')}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClickPopoverContent}
          >
            <ul>
              {assignees.slice(1).map((name, index) => (
                <li key={`assignee-${index}`} className={cn('text-sm font-normal text-foreground', 'px-2 py-1.5')}>
                  {name}
                </li>
              ))}
            </ul>
          </PopoverContent>
        </Popover>
      )}
    </div>
  )
}
